/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { AiResponse } from '@squiz/dxp-ai-client';
import { DataListItem, ICON_CHEVRON_RIGHT, SdsIcon } from '@squiz/sds';
import React from 'react';
import { NavigateFunction } from 'react-router-dom';
import { createAiListFooter } from './createAiListFooter';
import { navigateToAiListItem } from './navigateToAiListItem';

/**
 * Maps the Ai page response to the data list props.
 * @export
 * @param {Array<AiResponse>} items
 * @param {(item: AiResponse) => void} action
 * @return {*}  {Array<DataListItem>}
 */
export function mapPageResultItemsToListItems(
  items: Array<AiResponse>,
  navigate: NavigateFunction,
): Array<DataListItem> {
  return items.map((item: AiResponse) => {
    const footer = createAiListFooter(item);
    const dataListItem: DataListItem = {
      action: () => navigateToAiListItem(item, navigate),
      content: (
        <span className="item">
          <span className="title">{item.name}</span>
          <SdsIcon svg={ICON_CHEVRON_RIGHT}></SdsIcon>
        </span>
      ),
      dataId: item.id,
      footer: footer,
      id: item.id,
      key: item.id,
    };
    return dataListItem;
  });
}
